/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import { colorClassNames } from '../../styles/Colors';

const styleNone = {
  fill: 'none',
};

const IconMeasurements = (props) => (
  <svg className={colorClassNames.stroke(props.color)} height={props.size} viewBox="0 0 72.12 24">
    <g style={styleNone}>
      <rect x="50" y="6.43" width="4.49" height="15.57" rx="2.25" ry="2.25" />
      <rect x="57.75" y="2" width="4.49" height="20" rx="2.25" ry="2.25" />
      <rect x="65.51" y="12" width="4.49" height="10" rx="2.25" ry="2.25" />
      <rect x="26" y="6.43" width="4.49" height="15.57" rx="2.25" ry="2.25" />
      <rect x="33.75" y="2" width="4.49" height="20" rx="2.25" ry="2.25" />
      <rect x="41.51" y="12" width="4.49" height="10" rx="2.25" ry="2.25" />
      <rect x="2" y="6.43" width="4.49" height="15.57" rx="2.25" ry="2.25" />
      <rect x="9.75" y="2" width="4.49" height="20" rx="2.25" ry="2.25" />
      <rect x="17.51" y="12" width="4.49" height="10" rx="2.25" ry="2.25" />
    </g>
  </svg>
);
IconMeasurements.propTypes = {
  size: PropTypes.string,
  color: colorClassNames.nameProp,
};
IconMeasurements.defaultProps = {
  color: 'dark-neutral',
};

export default IconMeasurements;
